<div>
    <mat-spinner color="primary" [diameter]="40"></mat-spinner>
    <span *ngIf="loadingHintTranslationKey" class="loading-hint">
        {{ loadingHintTranslationKey | translate }}
    </span>
</div>